<template>
  <div class="third guanLiGZH">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content"
            >{{ ruleForm.columnName }}/管理公众号</span
          >
        </div>
        <div class="btn-right">
          <!-- <el-button @click="resetForm" class="btn-two" type="default"
            >重置</el-button
          >
          <el-button
            @click="commit"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
            >保存</el-button
          > -->
        </div>
      </div>
      <div class="formOne-forms">
        <div class="forms-one" style="margin-top: 57px">
          <div class="one-list">
            <div class="add-row">
              <el-button icon="el-icon-plus" @click="openAddDialog"
                >新增</el-button
              >
              <el-button
                class="do-btn-four"
                type="default"
                icon="el-icon-delete"
                @click="deleteItem(null)"
                >删除</el-button
              >
            </div>
            <div class="list-four-line">
              <el-table
                class="third-tableThree"
                :data="currentTableData"
                border
                stripe
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                row-key="officialAccountId"
              >
                <el-table-column
                  type="selection"
                  :reserve-selection="true"
                  width="55"
                >
                </el-table-column>
                <el-table-column
                  prop="mpName"
                  label="公众号名称"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  prop="modifiedValue"
                  label="公众号编号"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  prop="accountSubject"
                  label="账号主体"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  prop="mpType"
                  label="账号性质"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.mpType == 4 ? "部门号" : "订阅号" }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="description"
                  label="账号简介"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  prop="mpAccount"
                  label="订阅用户"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="{ row }">
                    <span
                      :style="{
                        color: row.status == '0' ? '#33CC99' : '#FF4D4F',
                      }"
                      >{{ row.status == "0" ? "启用" : "停用" }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="添加时间"
                  :show-overflow-tooltip="true"
                ></el-table-column>

                <el-table-column
                  prop="state"
                  label="操作"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <!-- <el-button
                        type="text"
                        size="small"
                        @click="updateStatus(scope.row, scope.$index)"
                      >
                        {{ scope.row.openStatus !== "1" ? "开启" : "关闭" }}
                      </el-button> -->
                    <!-- <span class="tableThree-height-shu">
                        <span class="shu-item"></span>
                      </span> -->
                    <el-button
                      type="text"
                      size="small"
                      @click="deleteItem(scope.row.id)"
                      :disabled="scope.row.editStatus === 'ALL'"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
    <addOfficalAccounts
      :addModalVisible="addModalVisible"
      @closeAddModal="closeAddModal"
      :choosedList="currentTableData"
      @addData="addData"
    ></addOfficalAccounts>
  </div>
</template>

<script>
import {
  newsSectionConfigOfficialAccountList,
  saveOfficialAccountList,
  mpList,
  removeOA,
} from "@/store/appconfig/inforMationConfig"; //我的
import { itemDetailPort, updatePort } from "@/api/appSetting/appServiceSetting";
import Sortable from "sortablejs";
import addOfficalAccounts from "./addOfficalAccounts";
// import { uniqBy } from "lodash";
import { uniqBy, cloneDeep } from "lodash";
import { getStore } from "@/utils/store";
import keyValueSelectVue from "../../../components/key-value/key-value-select.vue";
export default {
  name: "formSeven",
  props: ["rowId"],
  data() {
    return {
      concatArr: [],
      currentName: "",
      countNum: 1, //用于显示第一个错误
      addModalVisible: false,
      cpRowId: this.rowId,
      //   &********弹框******************************
      //   agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定启用删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      noticeSpec: "", // 标红提示
      //   &**************************************
      ruleForm: {
        id: "",
        columnName: "",
      },
      rules: {
        orderNum: [
          { required: true, message: "请输入栏目顺序", trigger: "blur" },
        ],
        showName: [
          { required: false, message: "请输入展示名称", trigger: "blur" },
        ],
        homeRow: [
          {
            required: true,
            message: "请选择公众号消息集合展示位置",
            trigger: "change",
          },
        ],
        openAll: [
          {
            required: true,
            message: "请选择公众号消息集合",
            trigger: "change",
          },
        ],
      },
      currentTableData: [],
    };
  },
  components: {
    addOfficalAccounts,
  },
  created() {
    let result = getStore({ name: "goAlumniDHTML", type: "session" });

    console.log(result);
    this.ruleForm.id = result.id;
    this.ruleForm.columnName = result.name;
    // document.body.ondrop = function (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // };
    Promise.all([this.mpList()]).then((res) => {
      this.itemDetail();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  watch: {
    rowId() {
      this.cpRowId = this.rowId;
    },
    currentTableData() {
      this.$nextTick(() => {
        this.rowDrop();
      });
    },
  },
  methods: {
    getlable(row) {
      //通过中台接口判断订阅用户
      console.log(this.concatArr);
      let value = "";
      if (!row["mpAccount"]) {
        value = "";
      } else {
        const arr = this.concatArr.filter((item) => {
          return item.phone == row.mpAccount;
        });
        value = arr[0].fansCount;
      }
      return value;
    },
    async mpList() {
      console.log("this.cpRowId", this.currentTableData);
      try {
        const {
          data: { result, msg, status },
        } = await mpList({
          accountSubject: "",
          code: "",
          endTime: "",
          isMessage: -1,
          managementId: "",
          mpType: 4,
          nickname: "",
          pageIndex: 1,
          pageSize: 40,
          pasuse: "-1",
          startTime: "",
        });
        const mpList2 = await mpList({
          accountSubject: "",
          code: "",
          endTime: "",
          isMessage: -1,
          managementId: "",
          mpType: 5,
          nickname: "",
          pageIndex: 1,
          pageSize: 40,
          pasuse: "-1",
          startTime: "",
        });
        if (status === 1000 && mpList2.data.status == 1000) {
          // this.$message.success("操作成功");
          // this.changeComponent();
          console.log("结果", result, mpList2.data.result);
          const newArr = result.data.concat(mpList2.data.result.data);
          console.log(newArr);
          this.concatArr = newArr;
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    // 删除
    deleteItem(row) {
      console.log(row);
      this.noticeSpec = "删除后，资讯栏目将不再展示该公众号的消息，"; // 标红提示
      (this.noticeType = 1), // 提示类型
        (this.agreeContent = "确认"); // 提示弹窗确认按钮内容
      this.noticeTitle = "提示"; // 提示
      this.noitceContent = "确定删除吗？"; // 提示信息
      if (row == null) {
        if (!this.checkID) {
          this.$message.error("请勾选数据");
        } else {
          this.deleteType = 3;
          this.noticeModal = true;
        }
      } else {
        this.delectID = row;
        this.deleteType = 2;
        this.noticeModal = true;
      }
    },
    //返回首页
    goBack() {
      this.$emit("fatherMethod", "adhibitionJPG");
    },
    //全选
    handleSelectionChange(selection) {
      console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].id);
      }
      this.checkID = this.checkClassList.join(",");
      console.log(this.checkID);
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit() {
      this.updateData();
      this.$refs.multipleTable.clearSelection();
      //   this.countNum = 0;
      //   this.$nextTick(() => {
      //     this.$refs.ruleForm.validate((valid) => {
      //       console.log("valid", valid);
      //       if (valid) {
      //         this.countNum = 1;
      //         this.updateData();
      //       } else {
      //         return false;
      //       }
      //     });
      //   });
    },
    //表单重置
    resetForm() {
      this.$refs.multipleTable.clearSelection();
      //   this.$refs.ruleForm.clearValidate()
      this.$nextTick(() => {
        this.itemDetail();
      });
    },
    //点击公众号弹框新增按钮
    async updateData(arr) {
      console.log("arr", arr);
      try {
        const {
          data: { result, msg, status },
        } = await saveOfficialAccountList({
          id: this.ruleForm.id,
          officialAccountIds: arr,
        });
        if (status === 1000) {
          this.$message.success("操作成功");
          this.addModalVisible = false;
          this.resetForm();
          console.log("结果", result);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    // deleteRowConfirm(rowData, index) {
    //   this.agreeNotice = () => {
    //     this.noticeModal = false
    //     this.deleteRow(index)
    //   }
    //   this.noticeModal = true
    // //   this.deleteRow(index);
    // },
    // 确认弹窗
    agreeNotice() {
      if (this.deleteType === 2) {
        // this.deleteRow(this.delectID);
        // this.currentTableData.splice(this.delectID, 1);
        const arr = [];
        let index = this.currentTableData.find((item1) => {
          return item1.id == this.delectID;
        });
        arr.push({
          officialAccountId: index.officialAccountId,
          newsSectionId: index.newsSectionId,
        });
        this.deleteRow(arr);
        this.noticeModal = false;
      } else if (this.deleteType === 3) {
        const arr2 = [];
        let arr1 = this.checkID.split(",");
        arr1.forEach((item) => {
          let index = this.currentTableData.find((item2) => {
            return item2.id == item;
          });
          //   debugger
          arr2.push({
            officialAccountId: index.officialAccountId,
            newsSectionId: index.newsSectionId,
          });
        });
        this.deleteRow(arr2);
        this.noticeModal = false;
      } else if (this.deleteType === 4) {
        this.noticeModal = false;
      }
    },
    //删除
    async deleteRow(arr) {
      try {
        const {
          data: { result, msg, status },
        } = await removeOA({
          id: this.ruleForm.id,
          officialAccountIds: arr,
        });
        if (status === 1000) {
          this.$message.success(msg);
          //   const arr = cloneDeep(result);
          //   let newArr = JSON.parse(JSON.stringify(arr));
          //   newArr.forEach((i, index) => {
          //     const newArr2 = this.concatArr.filter((item) => {
          //       return item.phone == i.mpAccount;
          //     });
          //     if (newArr2.length > 0) {
          //       newArr[index].mpAccount = newArr2[0].fansCount;
          //       newArr[index].modifiedValue = newArr2[0].phone; //新增属性modifiedValue作为公众号编号的映射值
          //       newArr[index].status = newArr2[0].isPasuse;
          //     }
          //   });

          //   this.currentTableData = newArr;
          //   console.log("结果", newArr);
          this.resetForm();
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    updateStatus(rowData, index) {
      if (rowData.openStatus === "1") {
        this.$set(this.currentTableData[index], "openStatus", "2");
        return;
      }
      this.$set(this.currentTableData[index], "openStatus", "1");
    },
    addData(list) {
      console.log(list);
      console.log(this.currentTableData);
      //   const newArr = [...list, ...this.currentTableData];
      //   newArr.forEach((i, index) => {
      //     const newArr2 = this.concatArr.filter((item) => {
      //       return item.phone == i.mpAccount;
      //     });
      //     if (newArr2.length > 0) {
      //       newArr[index].mpAccount = newArr2[0].fansCount;
      //       newArr[index].modifiedValue = newArr2[0].phone;
      //       newArr[index].status = newArr2[0].isPasuse;
      //     }
      //   });

      //   this.currentTableData = newArr;
      //   this.closeAddModal();
      const arr = [];
      list.forEach((item) => {
        arr.push({
          officialAccountId: item.officialAccountId,
          newsSectionId: this.ruleForm.id,
        });
      });
      this.updateData(arr);
      this.$refs.multipleTable.clearSelection();
    },
    closeAddModal() {
      this.addModalVisible = false;
    },
    openAddDialog() {
      this.addModalVisible = true;
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.currentTableData.splice(oldIndex, 1)[0];
          _this.currentTableData.splice(newIndex, 0, currRow);
          const newList = [..._this.currentTableData];
          _this.currentTableData = [];
          _this.$nextTick(() => {
            _this.currentTableData = [...newList];
          });
          console.log("_this.currentTableData", _this.currentTableData);
        },
      });
    },
    async itemDetail() {
      console.log("this.cpRowId", this.cpRowId);
      try {
        const {
          data: { result, msg, status },
        } = await newsSectionConfigOfficialAccountList({
          id: this.ruleForm.id,
        });
        if (status === 1000) {
          const arr = cloneDeep(result);
          let newArr = JSON.parse(JSON.stringify(arr));
          newArr.forEach((i, index) => {
            const newArr2 = this.concatArr.filter((item) => {
              return item.phone == i.mpAccount;
            });
            if (newArr2.length > 0) {
              newArr[index].mpAccount = newArr2[0].fansCount;
              newArr[index].modifiedValue = newArr2[0].phone; //新增属性modifiedValue作为公众号编号的映射值
              newArr[index].status = newArr2[0].isPasuse;
            }
          });

          this.currentTableData = newArr;
          console.log("结果", newArr);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    // 复制地址
    copyUrl(url, params) {
      let copy = (e) => {
        e.preventDefault();
        e.clipboardData.setData("text/plain", url + params);
        this.$message.success("操作成功");
        document.removeEventListener("copy", copy);
      };
      document.addEventListener("copy", copy);
      document.execCommand("copy");
    },
    // 改变index页面的component的值
    changeComponent() {
      this.$emit("changeComponent", "homePage");
    },
  },
};
</script>
<style lang="scss">
.guanLiGZH {
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    .el-button {
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .rows-copy {
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .single-row {
    min-width: 292px;
  }
  .row-goto {
    color: #2d8cf0;
    cursor: pointer;
  }
  .multi-rows {
    width: 676px;
  }
}
</style>
